import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const LibraryListView: DynamicImport = () => import(/* webpackChunkName: "communication" */ '../views/LibraryListView.vue')
const LetterParamsView: DynamicImport = () => import(/* webpackChunkName: "communication" */ '../views/LetterParamsView.vue')
const ModelListView: DynamicImport = () => import(/* webpackChunkName: "communication" */ '../views/ModelListView.vue')
const CommunicationParamsView: DynamicImport = () => import(/* webpackChunkName: "communication" */ '../views/CommunicationParamsView.vue')
const ReportTypesView: DynamicImport = () => import(/* webpackChunkName: "communication" */ '../views/ReportTypesView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    name: 'communication-files',
    path: 'communication/files',
    component: LibraryListView,
    meta: {
      title: i18n.t('communication.files.pageTitle'),
      pageHeader: false
    }
  },
  {
    name: 'communication-letters',
    path: 'communication/letters',
    component: LetterParamsView,
    meta: {
      title: i18n.t('communication.letters.pageTitle'),
      appModule: 'communication-letters'
    }
  },
  {
    name: 'communication-models',
    path: 'communication/models',
    component: ModelListView,
    meta: {
      title: i18n.t('communication.models.pageTitle'),
      pageHeader: false
    }
  },
  {
    name: 'communication-params',
    path: 'communication/params',
    component: CommunicationParamsView,
    meta: {
      title: i18n.t('communication.params.pageTitle')
    }
  },
  {
    name: 'communication-report-types',
    path: 'communication/report-types',
    component: ReportTypesView,
    meta: {
      title: i18n.t('communication.reportType.pageTitle')
    }
  }
])

export default routes
